import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=c3b156e2&"
import script from "./tip.vue?vue&type=script&lang=js&"
export * from "./tip.vue?vue&type=script&lang=js&"
import style0 from "./tip.vue?vue&type=style&index=0&id=c3b156e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports